module.exports = __webpack_public_path__ + "img/gzh.ca760d0b.jpg";